/* eslint-disable */
import {setCookie, getCookie} from "app/lib/cookies";
import {querySelector} from "app/lib/helperjs";

const COOKIE_BAR_CLASS = '.js-footer-cookies-bar';
const COOKIE_BTN_CLASS = '.js-footer-cookies-close';
const COOKIE_NAME = 'hide-cookies-bar';

export const FooterCookiesBar = () => {
    const bar = querySelector(COOKIE_BAR_CLASS);
    const btn = querySelector(COOKIE_BTN_CLASS);
    const removeBar = () => bar.parentNode.removeChild(bar);
    const showBar = () => bar.classList.remove('hide');
    
    if (!getCookie(COOKIE_NAME)) {
        showBar();
    }

    btn.addEventListener('click', () => {
        removeBar();
        setCookie(COOKIE_NAME, true, 365);
    })
};
